import React, { useState, useContext, useEffect } from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { getRateosList, getRateosCompanyList, addRateoCompany, deleteRateoCompany } from '../services/api_rateos';
import { AuthContext } from '../contexts/auth';
import Swal from 'sweetalert2';



const RateiTable = ({ showForm, setShowForm }) => {
    const [ratei, setRatei] = useState([]);
    const [rateiCompany, setRateiCompany] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { token } = useContext(AuthContext);

    
    useEffect(() => {
        const fetchRatei = async () => {
            setIsLoading(true);
            setError(null);
        
            try {
                const rateiData = await getRateosList(token);
                setRatei(rateiData);

                const rateiCompanyData = await getRateosCompanyList(token);
                setRateiCompany(rateiCompanyData);
            } catch (error) {
                setError(error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchRatei();
    }, [token]);
    

    const handleEnableRateo = async (rateoId) => {
        try {
            if (rateiCompany.find(r => r.id === rateoId)) {
                throw new Error('Rateo already enabled for the company');
            }
    
            await addRateoCompany(token, rateoId);
          
            const updatedRateiCompany = await getRateosCompanyList(token);
            setRateiCompany(updatedRateiCompany);
        } catch (error) {
            console.error('Errore nell\'abilitazione del rateo:', error);
        }
    };
    
    const handleDisableRateo = (companyRateoId) => {
        Swal.fire({
          text: 'Disabilitando il contatore verrà eliminato il relativo rateo salvato nei dipendenti. Confermi?',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#D1D5DB',
          confirmButtonText: 'Si, sono sicuro!',
          cancelButtonText: 'Annulla',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteRateoCompany(token, companyRateoId);
                    const updatedCompanyRateos = await getRateosCompanyList(token);
                    setRateiCompany(updatedCompanyRateos);
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Disabilitato!",
                        showConfirmButton: false,
                        timer: 1500
                    });
                } catch (error) {
                console.error('Errore durante la disabilitazione del rateo:', error);
                    Swal.fire({
                        title: 'Errore!',
                        text: 'Si è verificato un errore durante la disabilitazione del rateo.',
                        icon: 'error'
                    });
                }
            }
        });
    };
     
    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    return (
        <>
            <div className="flex flex-col sm:flex-row items-center my-4 justify-between">
                <div className="flex items-center mb-2 sm:mb-0 sm:mr-4">
                    <h3 className="text-sm font-semibold leading-6 text-gray-900 mr-4">I TUOI RATEI</h3>
                </div>
                <div>
                    <h5>Seleziona 'Abilita' per attivare l'allineamento automatico del contatore</h5>
                </div>
            </div>
        
            <fieldset className='min-w-full overflow-x-auto'>
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th colSpan={2} className="px-4 pl-4 sm:pl-10 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Descrizione</th>
                        <th colSpan={2} className="px-4 pl-4 sm:pl-10 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Stato</th>
                        <th colSpan={2} className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">Abilita/Disabilita</th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {ratei.map((rateo, rateoIdx) => {
                            const companyRateo = rateiCompany.find(companyRateo => companyRateo.rateo.name === rateo.name);
                            const companyRateoId = companyRateo ? companyRateo.id : null;

                            return (
                                <tr key={rateoIdx}>
                                    <td colSpan={2} className="px-4 pl-4 sm:pl-10 whitespace-nowrap text-gray-500 text-sm">{rateo.name}</td>
                                    {companyRateo ? (
                                        <>
                                            <td colSpan={2} className="px-4 pl-4 sm:pl-10 whitespace-nowrap text-gray-500 text-sm">
                                                <span className='bg-indigo-100 p-2 rounded-md'><CheckCircleIcon className="inline-block h-5 w-5 text-indigo-700" /> ON</span> 
                                            </td>
                                            <td colSpan={2} className="px-4 py-2 pl-10 whitespace-nowrap text-gray-500 text-sm justify-center flex">
                                                <button
                                                    onClick={() => companyRateoId !== null && handleDisableRateo(companyRateoId)}
                                                    className="border flex items-center rounded-md bg-grey-400 px-3 py-1 text-center text-xs font-semibold text-gray-900 shadow-sm hover:bg-gray-400 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 w-28 justify-center"
                                                >
                                                    Disabilita
                                                </button>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td colSpan={2} className="px-4 pl-10 whitespace-nowrap text-gray-500 text-sm">
                                                <span><XCircleIcon className="inline-block h-5 w-5 text-gray-500" /> OFF</span>
                                            </td>
                                            <td colSpan={2} className="px-4 py-2 pl-10 whitespace-nowrap text-gray-500 text-sm justify-center flex">
                                                <button
                                                    onClick={() => handleEnableRateo(rateo.id)}
                                                    className="border flex items-center rounded-md bg-grey-400 px-3 py-1 text-center text-xs font-semibold text-gray-900 shadow-sm hover:bg-indigo-700 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 w-28 justify-center"
                                                >
                                                    Abilita
                                                </button>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </fieldset>
        </>
    );
};

export default RateiTable;
